import React, { FunctionComponent } from 'react'

import styled, { useTheme } from 'styled-components/native'

import { ThemeType, tID } from '../../../utils'

const DividerContainer = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  paddingHorizontal: theme.breakpoints.isMobileSized ? theme.spacing['24px'] : theme.spacing['64px'],
  width: '100%',
}))

const DividerLine = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  height: 1,
  backgroundColor: theme.colors.dividerSecondary,
  width: '100%',
}))

export const AuroraSectionDivider: FunctionComponent = () => {
  const theme = useTheme() as ThemeType

  if (!theme.isAuroraTheme) {
    return null
  }

  return (
    <DividerContainer testID={tID('AuroraSectionDivider')}>
      <DividerLine />
    </DividerContainer>
  )
}
